import { AxiosInstance, AxiosResponse } from 'axios';
import { FilterSpecialOrders } from 'models/filter-specia-order.model';
import { RecordSpecialOrderResponse } from 'models/record-special-order-request.model';
import { SpecialOrderModel, SpecialOrderDTO } from '../../models/special-orders.model';
import ColisportApiResource from './colisport-api-resource.model';

export default class SpecialOrdersApi implements ColisportApiResource {
  readonly apiUrlPath = 'specialorder';

  constructor(readonly httpClient: AxiosInstance) {}

  async record(
    recordSpecialOrderRequest: RecordSpecialOrderResponse,
  ): Promise<AxiosResponse<void>> {
    return this.httpClient.post(`${this.apiUrlPath}/record`, recordSpecialOrderRequest);
  }

  async update(
    colisportID: string,
    data: Partial<SpecialOrderDTO>,
    isOneWay?: boolean,
  ): Promise<AxiosResponse<void>> {
    return this.httpClient.put(
      `${this.apiUrlPath}/update/${colisportID}?isOneWay=${String(isOneWay)}`,
      data,
    );
  }

  async getSpecialOrdersByEmail(
    email: string,
    isOneWay?: boolean,
  ): Promise<AxiosResponse<SpecialOrderModel[]>> {
    return this.httpClient.get(`${this.apiUrlPath}/orders/${email}?isOneWay=${String(isOneWay)}`);
  }

  async getSpecialOrderByColisportID(
    id: string,
    isOneWay?: boolean,
  ): Promise<AxiosResponse<SpecialOrderModel>> {
    return this.httpClient.get(`${this.apiUrlPath}/${id}?isOneWay=${String(isOneWay)}`);
  }

  async getSpecialOrdersBackOffice(query?: string): Promise<AxiosResponse<FilterSpecialOrders>> {
    return this.httpClient.get(`${this.apiUrlPath}/filters${query !== '' ? `?${query}` : ''}`, {
      params: `filters?${query}`,
    });
  }
}
